import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldX, Home, LogOut } from "lucide-react";

const AccessDenied = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate("/admin/login");
  };

  return (
    <Layout>
      <div className="container max-w-md py-24 flex flex-col items-center">
        <Card className="w-full text-center">
          <CardHeader>
            <div className="mx-auto mb-3 h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
              <ShieldX className="h-8 w-8 text-destructive" />
            </div>
            <CardTitle className="font-display text-2xl">Access Denied</CardTitle>
            <CardDescription className="text-base mt-2">
              {user
                ? "Your account doesn't have admin privileges. Please contact the site administrator if you believe this is an error."
                : "You need to sign in with an admin account to access this page."}
            </CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-3">
            <Button onClick={() => navigate("/")} variant="default" className="w-full">
              <Home className="mr-2 h-4 w-4" /> Go to Homepage
            </Button>
            {user ? (
              <Button onClick={handleSignOut} variant="outline" className="w-full">
                <LogOut className="mr-2 h-4 w-4" /> Sign Out & Switch Account
              </Button>
            ) : (
              <Button onClick={() => navigate("/admin/login")} variant="outline" className="w-full">
                Sign In
              </Button>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default AccessDenied;
